import React from "react";
import TeamFunctionCard from "../../components/PageComponents/Function/TeamFunctionCard";
import classes from "../../assets/styles/Pages/Function/Function.module.css";
import HeroSection from "../../components/HeroSection";
import TeamData from "../../utils/data/TeamData";

const Team = () => {
  return (
    <>
      <div className="mt-3 heading">
        <h1 className="title">Team</h1>
      </div>
      <div className="mainWrapper">
        <HeroSection />
      </div>

      <div className="row mt-5 g-4">
        {TeamData.map((card) => {
          return (
            <div className="col-12 col-md-6 col-lg-4" key={card.id}>
              <TeamFunctionCard key={card.id} {...card} />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Team;
